// Módulo compartido entre frontend (src/) y Netlify Function
// (netlify/functions/enviar-pedido.js). La validación vive una
// sola vez para que las reglas no diverjan en silencio.

export const LIMITS = {
  NOMBRE_MAX: 50,
  EMPRESA_MAX: 100,
  CANTIDAD_MAX: 9999,
  BUSQUEDA_MAX: 100,
  PRODUCTOS_MAX: 200,
  CODIGO_MAX: 10,
  NOMBRE_PRODUCTO_MAX: 120,
  UNIDAD_MAX: 60
};

// Caracteres invisibles/peligrosos: controles ASCII, DEL,
// zero-width chars, bidi overrides e isolates.
const INVISIBLE_CHARS_PATTERN = '[\\u0000-\\u001F\\u007F\\u200B-\\u200F\\u202A-\\u202E\\u2066-\\u2069]';
const INVISIBLE_CHARS = new RegExp(INVISIBLE_CHARS_PATTERN, 'g');

// Sanitiza texto libre: recorta longitud, colapsa espacios, remueve
// controles y caracteres invisibles para evitar inyección en el
// mensaje de WhatsApp.
export const sanitizeInput = (input, maxLength) => {
  if (!input || typeof input !== 'string') return '';
  return input
    .normalize('NFC')
    .replace(INVISIBLE_CHARS, '')
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, maxLength);
};

// Variante usada en frontend: devuelve string vacío para input vacío
// (estado intermedio de un input controlado), o null si es inválido.
export const sanitizeCantidad = (valor) => {
  if (valor === '' || valor === null || valor === undefined) return '';
  const str = String(valor).trim();
  if (!/^\d+$/.test(str)) return null;
  const n = parseInt(str, 10);
  if (Number.isNaN(n) || n < 0) return null;
  if (n > LIMITS.CANTIDAD_MAX) return String(LIMITS.CANTIDAD_MAX);
  return String(n);
};

// Variante usada en backend: solo enteros positivos, o null si inválido.
// El backend nunca acepta 0 ni vacío como cantidad válida.
export const sanitizeCantidadServidor = (valor) => {
  const n = Number.parseInt(valor, 10);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.min(n, LIMITS.CANTIDAD_MAX);
};
